import * as React from 'react';
import type { SVGProps } from 'react';
const SvgFlag01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M3 2.997c0-.255.098-.51.293-.704 0 0-.044.038.046-.044l.074-.064c.059-.048.137-.107.235-.173.198-.132.479-.29.856-.44C5.259 1.269 6.387 1 8 1c1.693 0 3.097.561 4.316 1.05l.055.022C13.64 2.579 14.72 3 16 3c1.387 0 2.26-.23 2.754-.428.248-.1.405-.192.488-.248a.96.96 0 0 0 .073-.053A1 1 0 0 1 21 3v11.999a.997.997 0 0 1-.293.708v.001a1.722 1.722 0 0 1-.12.107 2.926 2.926 0 0 1-.235.173c-.198.132-.479.29-.856.44-.755.303-1.883.572-3.496.572-1.693 0-3.097-.561-4.316-1.05l-.055-.021C10.36 15.42 9.28 15 8 15c-1.387 0-2.26.23-2.754.428a3.32 3.32 0 0 0-.246.11V22a1 1 0 1 1-2 0V2.997Z"
    />
  </svg>
);
SvgFlag01.displayName = 'Flag01';
export default SvgFlag01;
